import React from 'react'

export default function CenteredTitleSection(props) {
  return (
    <section className='section-centered-title'><div className='container'><h2 className='title'>{props.title}</h2></div></section>
  )
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/CenteredTitleSection.jsx